import { render, staticRenderFns } from "./DeletePart.vue?vue&type=template&id=59529c98"
import script from "./DeletePart.vue?vue&type=script&lang=js"
export * from "./DeletePart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports